import orderBy from "lodash/orderBy";
export var getCurrentSubscription = function (subscriptions) {
    var sortSubscriptions = orderBy(subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.filter(function (f) { return !f.hasExpired; }), ["id"], ["desc"]);
    return sortSubscriptions && sortSubscriptions.length ? sortSubscriptions[0] : {};
};
export var getStudentSubscription = function (subscription) {
    var currentSubscription = getCurrentSubscription(subscription);
    var subscriptionType = currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.type;
    if (!subscriptionType) {
        return "No Subscription";
    }
    if (subscriptionType.isRecurring) {
        return "RECURRING";
    }
    if (subscriptionType.isTrial) {
        return "TRAIL";
    }
    return "INITIAL";
};
//# sourceMappingURL=subscriptionUtils.js.map